<template>
    <div>
        <van-empty
            class="custom-image"
            :image="require('@/assets/ComingSoon.png')"
            description="更多功能正在开发中"
            />
            <p class="index" >敬 请 期 待...</p>
    </div>
</template>
<script>
import { Empty } from 'vant'
export default {
  components: {
    [Empty.name]: Empty
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.index{
    display: flex;
    justify-content: center;
    font-size: 30px;
}
    //占位符
    /deep/ .van-empty__image{
      width: 260px;
      height: 179px;
      margin-bottom: 32px;
      margin-top: 300px;
    }
    /deep/ .van-empty__description{
      font-size: 28px;
    }
    /deep/ .van-empty__description{
      font-size: 24px;
      color: #999999;
    }
</style>
